import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ReactiveFormsModule} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingCarga, ITrackingDocumentos, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { Placa } from 'src/app/model/datos-maestros/placa';
import { Chofer } from '../../../traslado-logist/model/model';
import { IAlmacen } from 'src/app/model/datos-maestros/dmaestrosModel';
import { ColDef, GridApi } from 'ag-grid-community';


@Component({
  selector: 'app-tracking-documentos',
  templateUrl: './tracking-documentos.component.html',
  styleUrls: ['./tracking-documentos.component.css']
})

export class TrackingDocumentosComponent implements OnInit {

  public DAT_TITULOS    = diccionarios.titulos.documentos;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;
  public DAT_BTNCSS = diccionarios.button.buttonsCss;

  public titleModal   : string;
  public loading      : boolean = false;
  public loadingFlete : boolean = false;
  public isCreate     : boolean = true;

  // Variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : any[] = [];
  public defaultColDef  : ColDef;
  public rowSelection   : any;
  public gridApi        : GridApi;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  // Variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listAgencias   : IAlmacen[] = [];
  public selected       : ITrackingViajes;
  public listDocumentos : ITrackingDocumentos [] = [];
  public listadoCargas  : ITrackingCarga [] = [];
  public tablaCelds     : any;

  public formulario = new FormGroup({
    idViaje       : new FormControl(''),
    tipo          : new FormControl('', Validators.required),
    proveedorId   : new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern('^[0-9]*$')]),
    proveedorNombre:new FormControl('', Validators.required),
    choferCedula  : new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    choferNombre  : new FormControl('', Validators.required),
    choferTelefono: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    placa         : new FormControl('', [Validators.required, Validators.maxLength(10)]),
    furgon        : new FormControl('', [Validators.required, Validators.maxLength(10)]),
    centroOrigen  : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    bodegaCarga   : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    fechaLlegada  : new FormControl('', Validators.required),
    observacion   : new FormControl('', Validators.maxLength(250)),
    estado        : new FormControl(),
    centroDestino : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    creadoPor     : new FormControl(''),
    modificadoPor : new FormControl(''),
    balanzaTicket : new FormControl(''),
    garitaTicket  : new FormControl(''),
    
    detallePlaca  : new FormControl('', Validators.required),
    detalleFurgon : new FormControl('', Validators.required),
    detalleDestino : new FormControl('')
    });

  public formDocumentos = new FormGroup({
    viajeId       : new FormControl('', Validators.required),
    familiaMaterial: new FormControl('', [Validators.required, Validators.maxLength(300)]),
    guiaRemision  : new FormControl('', [Validators.required,  Validators.maxLength(300)]),
    notaExpedicion: new FormControl('', [Validators.required, Validators.maxLength(300)]),
    fleteSap      : new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(10)]),
    centroOrigen  : new FormControl('', Validators.required),
    agenciaOrigen : new FormControl('', Validators.required),
    fletePesoNeto : new FormControl('', Validators.required),
    fletePesoBruto: new FormControl('', Validators.required),
    destino       : new FormControl(''),
    detalleDestino: new FormControl(''),
    ordenOrigen   : new FormControl(''),
    creadoPor     : new FormControl(''),
    //modificadoPor : new FormControl(''),
    esRegistro    : new FormControl(true), //Feat T.42031 6.5
  });

  public formCarga = new FormGroup({
    viajeId       : new FormControl('', Validators.required),
    tipo          : new FormControl('', Validators.required),
    descripcion   : new FormControl('', Validators.required),
    cantidad      : new FormControl('', [Validators.required,  Validators.pattern('^[0-9]*$')]),
    creadoPor     : new FormControl(''),
    modificadoPor : new FormControl(''),
    });

  constructor(
    private utilServices    : UtilsService,
    private dmaestrosAPI    : DatosMaestrosService,
    private logisticaAPI    : LogisticaService,
    private _catalogos      : CatalogosLogisticaService,
    private router          : Router,
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.DAT_TITULOS = diccionarios.titulos.documentos;
    this.tablaCelds = this._catalogos.getCabeceraDoc();
    this.isCreate = true;
    
    this.inicializar();
    this.cargarGridcomponent();

  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = this._catalogos.getColumnDefs();
    this.columnDefs.push(
      //{ cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.editar.bind(this), label: 'Editar'} },
      { cellRenderer: 'buttonRenderer', initialPinned:"left", width: 150, cellRendererParams: {onClick: this.nuevo.bind(this), label: 'Iniciar Documentos'} },
      //{ cellRenderer: 'buttonRenderer', initialPinned:"left", cellRendererParams: {onClick: this.actualizarEstado.bind(this), label: '=> A Anden'} },
      { cellRenderer: 'buttonRenderer', initialPinned:"left", width: 70, cellRendererParams: {onClick: this.imprimirCheck.bind(this), label: 'Imprimir'}},
    );
    
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  inicializar(){
    this.listTipos    = [];
    this.listCentros  = [];
    
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res) => {
      if(res)this.listCentros = res.map((e)=> {e.nombreCentro = e.idCentro +" - "+e.nombreCentro; return e});
    }, (err) => { 
      console.log(err.message); 
    });

    this.logisticaAPI.getTipos().subscribe((res) => {
      if(res) this.listTipos = res; 
    }, (err) => { 
      console.log(err.message); 
    });

    this.listar();
  }

  nuevo({rowData}) {
    console.log(rowData);
    let detalleDestino = [rowData?.centroDestino, rowData?.almacenDestino] //Feat T.42031 6.4 6.3
      .filter(Boolean)
      .join(" - ");

      let detalleDestino2 = [rowData?.centroDestinoNombre, rowData?.almacenDestino] //Feat T.42031 6.4 6.3
      .filter(Boolean)
      .join(" - ");

    this.isCreate   = false;
    this.selected   = rowData;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;

    this.formDocumentos.reset(rowData);
    if(rowData.bodegaCarga != null) this.getAlmacen(rowData.centroOrigen);
    //this.formDocumentos.patchValue(rowData);
    this.formDocumentos.get('creadoPor').setValue(this.usarioActual.login2);
    this.formDocumentos.get('viajeId').setValue(this.selected.idViaje);
    this.formDocumentos.get('destino').setValue(detalleDestino?.trim()); //Feat T.42031 6.4 6.3
    this.formDocumentos.get('detalleDestino').setValue(detalleDestino2?.trim()); //Feat T.42031 6.4 6.3
    this.formDocumentos.get('agenciaOrigen').setValue(this.selected.bodegaCarga); //Feat T.42031 6.4 6.3
    this.formDocumentos.get('esRegistro').setValue(true);

    this.formCarga.reset();
    this.formCarga.get('creadoPor').setValue(this.usarioActual.login2);
    this.formCarga.get('viajeId').setValue(this.selected.idViaje);
    
    this.listarDocumentos();
    this.getDetalleCargas();
  }

  editar({rowData}){
    this.isCreate  = false;
    this.selected = rowData;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;

    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.formulario.get('modificadoPor').setValue(this.usarioActual.login2)

    this.openModal();
    this.getProveedor();
    this.getChofer();
    this.getAlmacen(this.formulario.get('centroOrigen'));
  }

  delete({rowData}){
    this.loading = true;

    this.utilServices.confirmarSincronoPromesa({
        title : diccionarios.mensajes.eliminar,
        text  : this.GLOBAL_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.logisticaAPI.deleteViaje(rowData.idViaje),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  listar(){
    this.loading = false;
    this.rowData = null;
    this.selected = null;
    this.logisticaAPI.getViajesByEstado('ANDEN_CARGADO').subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => { 
      console.log(err.message); 
    });
  }

  /** Si el form esta en modo de creación hará post caso contrario un update, ver variable isCreated */
  saveForm() {
    this.getFormValidationErrors();
    if (this.formulario.invalid) return;
    
    this.loading  = true;
    const payload =  this.formulario.getRawValue();
    let mensajeP  = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
   
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.logisticaAPI.createViaje(payload) : this.logisticaAPI.updateViaje(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  acciones(event) {
    if (event === 'regresar') {
      this.isCreate = true;
      this.selected = null;
      return this.closeModal();
    }

    this.actualizarEstado();
    //this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  /** METODOS DE CONSULTAS  */
  proveedorSelected;
  getProveedor(){
    let pathParam = this.formulario.get('proveedorId').value;
  
    this.formulario.get('proveedorNombre').reset();
    this.dmaestrosAPI.getProveedorByID(pathParam).subscribe((res) => {
      if(res){
        this.proveedorSelected = res;
        this.formulario.get('proveedorNombre').setValue(this.proveedorSelected.nombre);;
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
        this.proveedorSelected = null;
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  // En la tabla de placas se encuentra tanto el Furgon como la Placa de cabezal
  getPlaca(isPlaca: boolean = true){
    let pathParam = isPlaca ? this.formulario.get('placa').value : this.formulario.get('furgon').value;

    if(isPlaca){
      this.formulario.get('proveedorId').reset();
      this.formulario.get('detallePlaca').reset();
    }else{
      this.formulario.get('detalleFurgon').reset();
    }

    this.dmaestrosAPI.getPlacabyId(pathParam).subscribe((res: Placa) => {
      if(res){
        if(isPlaca){
          this.formulario.get('proveedorId').setValue(res.cedula);
          this.formulario.get('detallePlaca').setValue(res.marca);
          this.getProveedor();
        }else{
          this.formulario.get('detalleFurgon').setValue(res.marca);
        }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => { 
      console.error(err.message); 
    });

  }

  getChofer(){
    let pathParam = this.formulario.get('choferCedula').value;
    this.formulario.get('choferNombre').reset();

    this.dmaestrosAPI.getChoferByCedula(pathParam).subscribe((res: Chofer) => {
      if(res){
        this.formulario.get('choferNombre').setValue(res.nombres);
        if(this.isCreate) 
          {
            this.formulario.get('choferTelefono').reset();
            this.formulario.get('choferTelefono').setValue(res.fono);
          }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }  

  getAlmacen(idCentro:any = null){
    this.listAgencias = null;
    let pathParam = this.formDocumentos.get('centroOrigen').value;
    console.log("llamando almacenes CENTRO", idCentro);
    
    //if(idCentro == null) pathParam = this.formulario.get('centroOrigen').value;
    //console.log("llamando almacenes", idCentro);
    this.dmaestrosAPI.getAllAlmacenByCentro(pathParam).subscribe((res) => {
      if(res){
        this.listAgencias = res;
        this.listAgencias = this.listAgencias.map(e => {e.dscaAlmacen = e.idAlmacen + ' - ' + e.dscaAlmacen; return e;});
      }else{
        console.log("listar almacenes", res);
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.message); 
    });
  }

  actualizarEstado({ rowData }: { rowData?: any } = {}){
    this.selected.estado = 'BALANZA_OUT';
    let estadoActualizar = "BALANZA_OUT";
    const data = rowData == null ? this.selected : rowData;

    // VENTA GRANELES
    //01-04-2026 cambio nuevamente a estado CONVOY_PLANIFICADO
    let escenario = this.listTipos.filter(e=>e.idTipo == this.selected.tipo)[0];
    const ventaGraneles = (escenario.tipoEscenario == "VENTA" && this.selected.tipoCarga == 2);
    if(ventaGraneles){
      this.selected.estado = 'CONVOY_PLANIFICADO';
      estadoActualizar = "CONVOY_PLANIFICADO";
    }
    //end venta graneles
    console.log("valor seleccionado", rowData);

    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro que desea finalizar la DOCUMENTACION del viaje?. Viaje a " + estadoActualizar,
        text    : 'VIAJE ' + this.selected.idViaje,
        action  : "Actualizar Viaje",
        funcion : this.logisticaAPI.updateViajeEstado(this.selected.idViaje, estadoActualizar, this.usarioActual.login2)
      }).then(() => {
        this.loading = false;
        this.listar();        
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });    
  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;
    Object.keys(this.formDocumentos.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formDocumentos.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    console.log('Number of errors: ', totalErrors);
  }

  infoFlete: any;
  getFleteDataSap(){
    let pathParam = this.formDocumentos.get('fleteSap').value;

      if(pathParam){
        this.clearFleteData();
        this.loadingFlete = true;
        //this.logisticaAPI.getFleteDataSap(pathParam).subscribe((res) => {
        this.logisticaAPI.getFleteSapDetail(pathParam).subscribe((res) => {
          if(res && res.length > 0){
            const pesoNeto = Math.round(res.reduce((acc, item) => acc + (Number(item.pesoNeto) || 0), 0) * 100) / 100;
            const pesoBruto = Math.round(res.reduce((acc, item) => acc + (Number(item.pesoBruto) || 0), 0) * 100) / 100;
            const grupos = [...new Set(res.map(item => item.numEntrega))];
            const guias = [...new Set(res.map(item => item.nroSri).filter(item => item != null))];
            this.infoFlete = res;

            this.formDocumentos.get('fletePesoNeto').setValue(pesoNeto);
            this.formDocumentos.get('fletePesoBruto').setValue(pesoBruto);
            this.formDocumentos.get('notaExpedicion').setValue(grupos.join(",").substring(0,299));
            this.formDocumentos.get('guiaRemision').setValue(guias.join(",").substring(0,299));
            this.formDocumentos.get('ordenOrigen').setValue("SAP");
            
            this.getFleteFamilias();
          }else{
            this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
          }
          this.loadingFlete = false;
        }, (err) => { 
          this.loadingFlete = false;
          this.formDocumentos.get('ordenOrigen').setValue("MANUAL");
          this.utilServices.mensajeErroToast(err.message, 3000);
          console.log(err.message); 
        });
    }
  }

  clearFleteData(){
    this.formDocumentos.get('fletePesoNeto').setValue('');
    this.formDocumentos.get('fletePesoBruto').setValue('');
    this.formDocumentos.get('notaExpedicion').setValue('');
    this.formDocumentos.get('guiaRemision').setValue('');
    this.formDocumentos.get('familiaMaterial').setValue('');
    this.infoFlete = [];
  }

  getFleteFamilias(){
    let pathParam = this.formDocumentos.get('fleteSap').value;
    
    this.logisticaAPI.getFleteFamiliaDataSap(pathParam).subscribe((res) => {
      if(res){
        const grupos = res.map(item => item.grupoDescripcion);
        let familias = grupos.join(",");
        this.formDocumentos.get('familiaMaterial').setValue(familias.substring(0,299));
      }else{
        this.utilServices.mensajeOKToast("Sin registos ingrese familias manuales", 3000);
      }
    }, (err) => { 
      this.utilServices.mensajeErroToast(err.message, 3000);
      console.log(err.message); 
    });
  }

  /*Metodos para proceso de documentos*/
  listarDocumentos(){
    this.listDocumentos = [];

    this.logisticaAPI.getByViajeDocumentos(this.selected.idViaje).subscribe((res) => {
      if(res){
        this.listDocumentos = res;
      }
    }, (err) => { 
      this.utilServices.mensajeErroToast(err.message, 3000);
      console.log(err.message); 
    });

  }

  addDocumento(){
    let documento = this.formDocumentos.getRawValue();
    const payload = documento;

    this.logisticaAPI.createViajeDocumentos(payload).subscribe((res) => {
      if(res){
        this.utilServices.mensajeOKToast("Documento agregado");
        this.listarDocumentos();
      }
    }, (err) => { 
      console.log(err.message); 
    });

  }

  deleteDocumento(item){
    this.logisticaAPI.deleteViajeDocumentos(item.viajeId, item.fleteSap).subscribe((res) => {
        console.log("respuesta eliminado", res);
        this.utilServices.mensajeOKToast("Documento eliminado exitosamente");
        this.listarDocumentos();
    }, (err) => { 
      console.log(err.message); 
    });

  }
  
  /*Metodos para proceso de detalle de cargas*/
  saveDetalleCarga(){
    const payload = this.formCarga.getRawValue();

    this.logisticaAPI.createViajeCarga(payload).subscribe((res) => {
      if(res){
        this.utilServices.mensajeOKToast("Carga Actualizada");
        this.getDetalleCargas();
      }
    }, (err) => { 
      this.utilServices.mensajeErroToast(err.message, 3000);
      console.log(err.message); 
    });

  }

  getDetalleCargas(){
    this.listadoCargas = [];
    this.logisticaAPI.getByViajeCarga(this.selected.idViaje).subscribe((res) => {
      this.listadoCargas = res;
      console.log("resultado de consulta de carga, ", res);
      console.log("listado de cargas", this.listadoCargas);
    }, (err) => { 
      console.error(err.message); 
    });


    this.listDocumentos = [];

    this.logisticaAPI.getByViajeDocumentos(this.selected.idViaje).subscribe((res) => {
      if(res){
        this.listDocumentos = res;
      }
    }, (err) => { 
      this.utilServices.mensajeErroToast(err.message, 3000);
      console.log(err.message); 
    });


  }

  deleteCargas(item){
    this.logisticaAPI.deleteViajeCarga(item).subscribe((res) => {
        this.utilServices.mensajeOKToast("Carga eliminada exitosamente");
        this.getDetalleCargas();
    }, (err) => { 
      console.log(err.message); 
    });
  }

  imprimirCheck({rowData}){
    this.logisticaAPI.downloadReporteSalida(rowData.idViaje, this.usarioActual.login2).subscribe({
      next: (blob: Blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = `reporte_salida_${rowData.idViaje}.pdf`;
        anchor.click();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      },
      error: (err) => {
        const message = err?.message || 'No se pudo generar el PDF';
        this.utilServices.mensajeErroToast(message, 3000);
      }
    });
  }

  //Feat T.42031 6.1
  imprimirCheckInterno(){
    this.imprimirCheck({rowData: this.selected});
  }

}
